<script lang="ts">
  import { Column, FormGroup, Grid, Row, Tile } from "carbon-components-svelte";
  import type APIClient from "src/ts/APIClient";
  import FileUpload from "./FileUpload.svelte";
  import type { IImage } from "src/ts/Interfaces";
  import ImagePositioning from "./ImagePositioning.svelte";
  import { optionsData } from "./../../ts/Stores";

  export let client: APIClient;
  export let canvasWidth: number;
  export let canvasHeight: number;
  export let images: IImage[] = [];
  let uploadedFileIds: string[] = [];

  let defaultPositionPresets: string[];
  optionsData.subscribe((optionsData) => {
    defaultPositionPresets =
      optionsData.positioningOptions.defaultPositionPresets;
  });

  function updateImages(uploadedFileIds) {
    uploadedFileIds.forEach((id) => {
      images = [
        ...images,
        {
          imageId: id,
          positionPreset: defaultPositionPresets,
          usePositionPreset: true,
          placement: {
            widthInPercentage: 50,
            heightInPercentage: 50,
            xPostionInPercentage: 50,
            yPostionInPercentage: 50,
          },
        },
      ];
    });
  }

  let removeImage = (c) => {
    if (images.length > 0) {
      images = images.filter(function (value, index, array) {
        if (index != c) return value;
      });
    }
  };

  $: updateImages(uploadedFileIds);
</script>

<div class="stack">
  <FormGroup legendText="Upload a logo (or multiple images)" noMargin>
    <FileUpload {canvasWidth} {canvasHeight} bind:uploadedFileIds {client} />
    {#if images.length > 0}
      {#each images as image, c}
        <ImagePositioning bind:image on:click={() => removeImage(c)} {client} />
      {/each}
    {/if}
  </FormGroup>
</div>
